<template>
    <div class="contact-related-list">
        <div class="contact-related-list__container">
            <div class="contact-related-list__menu" v-if="contactRelatedListModules.length > 0">
                <div
                    v-for="module in contactRelatedListModules"
                    :key="module.id"
                    @click="selectedModule = module"
                    class="contact-related-list__menu-item"
                    :class="{ selected: $_.get(selectedModule, 'moduleName') === module.moduleName }"
                >
                    <i class="material-icons">{{ module.icon || "list" }}</i>
                    <span>{{ module.displayName }}</span>
                </div>
            </div>

            <div
                class="contact-related-list__content"
                v-if="contactRelatedListModules.length > 0"
                :key="$_.get(selectedModule, 'moduleName')"
            >
                <div class="contact-related-list__content-inner" v-if="selectedModule">
                    <TableDetail
                        :defaultRecords="records"
                        :moduleMode="true"
                        :defaultTableId="selectedModule.relation.standartToTable.to.table"
                        :predefinedValues="getTablePredefinedValues()"
                        @record-created="onRecordCreated"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import TableDetail from "../Tables/detail/TableDetail.vue";
import { MODULE_API } from "../../../api/module";
export default {
    components: {
        TableDetail,
    },
    data() {
        return {
            selectedModule: null,
            records: [],
            loading: false,
        };
    },
    props: {
        contactId: {
            type: String,
            required: true,
        },
        contact: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters("module", ["contactRelatedListModules"]),
    },
    methods: {
        redirectToTables() {
            this.$router.push("/tables");
        },
        fetchRelatedModuleRecords() {
            return MODULE_API.getContactRelatedListRecords(this.selectedModule.moduleName, this.contactId)
                .then((result) => {
                    this.records = result.items;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getTablePredefinedValues() {
            const module = this.selectedModule;
            if (!module || !module.relation) return {};

            let filterFieldId;
            let filterValue;

            if (module.relation.type === 'standart-to-table') {
                const fromConnection = module.relation.standartToTable.from;
                const toConnection = module.relation.standartToTable.to;

                // Karşı tabloda filtreleme yapılacak alanı belirle
                filterFieldId = toConnection.connectionType === 'field' ? toConnection.field : null;

                // Contact'tan değeri al
                if (fromConnection.connectionType === 'field') {
                    // Standart alan için (name, email, phone vb.)
                    filterValue = this.contact[fromConnection.field];
                } else if (fromConnection.connectionType === 'customProperties') {
                    // Özel alan için
                    const contactProperty = this.contact.contactProperties.find(
                        prop => prop.property._id.toString() === fromConnection.field
                    );
                    filterValue = contactProperty ? contactProperty.value : null;
                }
            }

            // Eğer filterFieldId null ise, bu _id ile filtreleme yapılacak demektir
            // Bu durumda predefined values boş dönmeli çünkü TableDetail komponenti
            // defaultRecords üzerinden zaten filtrelenmiş verileri alacak
            if (!filterFieldId) {
                return {};
            }

            return {
                [filterFieldId]: filterValue
            };
        },
        onRecordCreated(newRecord) {
            this.fetchRelatedModuleRecords();
        },
    },
    created() {
        this.selectedModule = this.contactRelatedListModules[0];
    },
    watch: {
        selectedModule: {
            handler(newVal) {
                this.records = [];
                this.fetchRelatedModuleRecords();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.contact-related-list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    &__container {
        display: flex;
        height: 100%;
    }

    &__menu {
        flex: 0 0 200px;
        border-right: 1px solid #e8e8e8;
        height: 100%;
        &-item {
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            padding: 8px;
            border-radius: 4px;
            font-size: 14px;
            color: #333;
            &:hover {
                background-color: #f0f0f0;
            }
            &.selected {
                background-color: #e8e8e8;
            }
        }
    }

    &__create-button {
        margin-bottom: 16px;
    }

    &__content {
        flex: 1;
        height: 100%;
        width: 100%;
        overflow: hidden;
        &-inner {
        }

        .table-body {
            width: 100%;
            overflow: scroll;
        }
    }
}
</style>
